
<section class="container">
  <div class="d-flex justify-content-end">
    <button [disabled]="cnaeImpedido.length == 0" class="btn btn-secondary m-0" type="button" (click)="btnExportarCnaes()"
    placement="top" ngbTooltip="Exporta todos os CNAEs impedidos listados">
    <i class="fa fa-file"></i> Exportar CNAEs impedidos</button>
  </div>
  <bn-paginacao [total]="atributosPaginacao.count"
  [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
  [opcoesTamanhoPagina]="opcoesPaginacao"
  (aoMudar)="mudancaPagina($event)">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">Máscara</th>
            <th scope="col">Tipo da Operação</th>
            <th scope="col">Objetivo do Financiamento</th>
            <th scope="col">Início da Validade de Impedimento</th>
            <th scope="col">Fim da Validade de Impedimento<th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of cnaeImpedido">
            <td>{{item.mascara}}</td>
            <td>{{labelOperacao(item.codigoTipoOperacao)}}</td>
            <td>{{labelObjetivoFinanciamento(item.codigoObjetivoFinanciamento)}}</td>
            <td>{{item.dataInicioValidadeImpedimento | date: 'dd/MM/yyyy'}}</td>
            <td>{{item.dataFimValidadeImpedimento | date: 'dd/MM/yyyy'}}</td>
            <td class="text-start" id=col-acoes>
              <a *ngIf="permissaoEdicao && item.dataFimValidadeImpedimento == null" href="javascript:void(0)" bnConfirm tituloConfirm="Confirmação"
                msgConfirm="Confirmar exclusão?" (onConfirm)="excluiRepasse(item.id)">
                <i class="fa fa-trash cursor-pointer ms-5" placement="left-top" ngbTooltip="Excluir CNAE"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </bn-paginacao>
</section>
